function onlyDigits(s) {
  return String(s || '').replace(/\D/g, '');
}

export function normalizePIVA(s) {
  return onlyDigits(s);
}

export function validatePIVA(piva) {
  const s = onlyDigits(piva);
  if (s.length !== 11) return false;
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    const n = s.charCodeAt(i) - 48;
    if (i % 2 === 0) {
      sum += n;
    } else {
      const x = n * 2;
      sum += x > 9 ? x - 9 : x;
    }
  }
  const control = (10 - (sum % 10)) % 10;
  return control === (s.charCodeAt(10) - 48);
}

export function validateCompanyFiscalCode(cf) {
  const s = onlyDigits(cf);
  if (s.length !== 11) return false;
  return validatePIVA(s);
}
